export default "__VITE_ASSET__By6Q1Qt8__"